// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1wxpx","content":"_3DK3M"};